module.exports = __webpack_public_path__ + "static/media/mental_load.6dd80b0f.jpg";